package ru.dinarastepina.fabvocab.web.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import ru.dinarastepina.fabvocab.web.theme.Indigo600
import ru.dinarastepina.fabvocab.web.theme.Slate100

@Composable
fun ProgressBar(
    progress: Float,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .height(6.px)
            .backgroundColor(Slate100)
            .borderRadius(50.percent),
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth((progress.coerceIn(0f, 1f) * 100).percent)
                .height(6.px)
                .backgroundColor(Indigo600)
                .borderRadius(50.percent),
        )
    }
}
